import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Phone } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { PHONE_TEL, PHONE_DISPLAY } from "@/lib/apiClient";

export const Header = () => {
  const { cartCount } = useStore();
  const loc = useLocation();
  const nav = [
    { to: "/", label: "Accueil" },
    { to: "/commander", label: "Commander" },
    { to: "/mes-commandes", label: "Mes commandes" },
  ];
  return (
    <header className="sticky top-0 z-40 bg-white border-b border-black" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <img src="/logo-asia.png" alt="Asia Take Away" className="h-10 w-auto" />
          <span className="font-display text-xl sm:text-2xl font-extrabold tracking-tighter">ASIA TAKE AWAY</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm font-medium transition-colors hover:text-brand-red ${
                loc.pathname === n.to ? "text-brand-red" : "text-black"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={`tel:${PHONE_TEL}`} data-testid="header-phone" className="hidden sm:flex items-center gap-2 text-sm font-medium hover:text-brand-red">
            <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
          </a>
          <Link to="/commander" data-testid="header-cart" className="relative flex items-center justify-center w-10 h-10 bg-black text-white">
            <ShoppingBag className="w-5 h-5" />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-brand-red text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-bold">
                {cartCount}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};

export const Footer = () => (
  <footer className="bg-black text-white mt-20" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-4 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <div className="font-display text-3xl font-extrabold tracking-tighter">ASIA TAKE AWAY</div>
        <p className="mt-4 text-white/60 text-sm">Cuisine asiatique à emporter & en livraison à Lausanne.</p>
      </div>
      <div className="text-sm space-y-2">
        <p className="font-display text-lg font-bold">Contact</p>
        <p className="text-white/70">Rue des Oliviers 1, 1018 Lausanne</p>
        <a href={`tel:${PHONE_TEL}`} className="block text-brand-red font-semibold" data-testid="footer-phone">{PHONE_DISPLAY}</a>
      </div>
      <div className="text-sm space-y-2">
        <p className="font-display text-lg font-bold">Liens</p>
        <Link to="/commander" className="block text-white/70 hover:text-white">Commander</Link>
        <Link to="/mes-commandes" className="block text-white/70 hover:text-white">Suivi de commande</Link>
      </div>
    </div>
    <div className="border-t border-white/10 py-4 text-center text-xs text-white/40">© {new Date().getFullYear()} Asia Take Away — Lausanne</div>
  </footer>
);
